import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrudService } from '@app/api/api-services/crud.service';
import { CorrectiveActionApiModel, SideEffectsApiModel } from '@app/api/api-models';

@Injectable()
export class CorrectiveActionsService extends CrudService<CorrectiveActionApiModel, string> {
  public apiUrl = 'corrective-actions';

  public getPrint(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/print`, { responseType: 'blob' });
  }

  public getSideEffects(id: string): Observable<SideEffectsApiModel> {
    return this.http.get<SideEffectsApiModel>(`${this.apiUrl}/${id}/side-effects`);
  }
}
